import React from 'react';

/**
 * React 18's `forwardRef` types reject the generic
 * `<C extends React.ElementType>` render functions our polymorphic atoms
 * (Button, Field, Chip, etc.) rely on: the inferred `ForwardRefRenderFunction`
 * is no longer assignable to a generic render function, and the resulting
 * `ForwardRefExoticComponent` is not assignable back to the component's
 * call-signature type.
 *
 * This wrapper accepts any polymorphic render function and returns a component.
 * Callers cast the result to their specific polymorphic component type (e.g.
 * `as unknown as ButtonComponent`) to preserve the `as`-prop typing for
 * consumers. It restores the pre-React-18 behavior without weakening consumer
 * call sites.
 */
export function polymorphicForwardRef(
  render: (props: any, ref: any) => React.ReactNode
): React.ForwardRefExoticComponent<any> {
  return React.forwardRef(render as React.ForwardRefRenderFunction<unknown, any>);
}
